import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class ListBmaReview {

    constructor() {
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(swiper => {
            swiper?.destroy(true, true);
        });

        this.instances = [];
        this.ready();
    }

    ready() {
        const swipers = document.querySelectorAll('.page-bma-review .swiper-wrapper-block .swiper');
        if (!swipers.length) return;

        swipers.forEach(slider => {
            const wrapper = slider.closest('.swiper-wrapper-block');

            const navigationNext = wrapper?.querySelector('.slider-button-next');
            const navigationPrev = wrapper?.querySelector('.slider-button-prev');

            const swiperInstance = new Swiper(slider, {
                modules: [Pagination, Navigation],
                spaceBetween: 24,
                grabCursor: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                roundLengths: true,
                lazyPreloadPrevNext: 2,

                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,

                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    1024: {
                        slidesPerView: 'auto',
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 30,
                    }
                }
            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push(swiperInstance);
        });
    }
}

if (document.querySelector('.page-bma-review')) {
    new ListBmaReview();
}
